import React from 'react';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../controls/selectInput.jsx';
import TextInput from '../../../controls/textInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';
import NumberInput from "../../../controls/numberInput";

export default class AdminCompaniesForm extends React.Component {
    constructor(args) {
        super(args);

        let companyId = this.props.match.params.id;
        this.state = {
            id: companyId ? companyId : 0,
            busyCount: 0,
            lastResponseError: null,
            carriers: [],
            companiesUS: [],
            errors: {},
            company: {}
        };

        this.initCompanyData();
    }

    initCompanyData() {
        this.state.company = {
            name: "",
            inn: "",
            carrierId: null,
            isActive: true,
            isInsuranceRequired: false,
            showNewParcelForm: true,
            feeUsingYourCarrier: null,
            companyUsId: null,
            carriers: []
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(newProps) {
        let companyId = newProps.match.params.id;
        this.state.id = companyId ? companyId : 0;
        this.setState(this.state, () => {
            if (this.state.id > 0) {
                this.reloadCompanyData();
            } else {
                this.initCompanyData();
                this.setState(this.state);
            }
        });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('ref/companiesus/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.companiesUS = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('admin/companies/ref/allcarriers')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.carriers = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.reloadCompanyData();
    }

    reloadCompanyData() {
        if (this.state.id == 0) {
            this.setState((prevState, props) => {                
                return prevState;
            });
        }
        else {
            //edit
            this.updateBusyCount(1);
            apiGet('admin/companies/' + this.state.id)
                .then(data => {
                    this.updateBusyCount(-1);
                    data.name = data.name ? data.name : "";
                    data.carriers = data.selectedCarriers.map(entry => entry.id);                    
                    data.comment = data.comment;
                    this.setState((prevState, props) => {
                        prevState.company = data;
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    if (err.status > 401) {
                        this.setState({ lastResponseError: err.status });
                    }
                });
        }
    }

    save() {
        let errors = this.validateForm();
        if (errors) {
            this.setErrors(errors);
        } else {
            var companyData = {
                id: this.state.id,
                name: this.state.company.name,
                inn: this.state.company.inn,
                kpp: this.state.company.kpp,
                isActive: this.state.company.isActive,
                comment: this.state.company.comment,
                companyUsId: this.state.company.companyUsId,
                showNewParcelForm: this.state.company.showNewParcelForm,
                isInsuranceRequired: this.state.company.isInsuranceRequired,
                selectedCarriers: this.state.company.carriers,
                feeUsingYourCarrier: this.state.company.feeUsingYourCarrier
            };

            var applyMethod = null;
            if (this.state.id > 0) {
                applyMethod = apiPost('admin/companies/' + this.state.id, companyData);
            } else {
                applyMethod = apiPut('admin/companies/new', companyData);
            }

            applyMethod
                .then(() => {
                    this.backToList();
                })
                .catch(errors => {
                    this.setErrors(errors.messages);
                });
        }
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateForm() {
        var result = null;
        if (this.isEmptyString(this.state.company.name)) {
            result = {};
            result.name = "Юр.лицо клиента является обязательным полем";
        }

        if (!this.state.company.companyUsId) {
            result = result ? result : {};
            result.companyUsId = "Юр. лицо US является обязательным полем";
        }

        if (this.isEmptyString(this.state.company.inn)) {
            result = result ? result : {};
            result.inn = "ИНН является обязательным полем";
        }
        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    backToList() {
        this.props.history.push('/admin/companies/list');
    }

    handleTextInputChange(name, value) {
        let company = this.state.company;
        company[name] = value;
        this.setState({
            company: company
        });
    }

    handleCompanyUSChange(selection) {
        this.state.company.companyUsId = selection ? selection.value : null;
        this.setState(this.state);
    }

    handleCarriersChange(selection) {
        if (selection) {
            this.state.company.carriers = selection.map((entry, ind, array) => entry.value);
        } else {
            this.state.company.carriers = [];
        }
        this.setState(this.state);
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('Financial');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }

        let isNew = this.state.id < 1;
        let isBusy = this.state.busyCount > 0;
        let header = isNew
            ? (
                <section className="content-header">
                    <h1>Новое юр. лицо</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/companies/list">Юр. лица клиентов</NavLink></li>
                        <li className="active">Новое юр. лицо</li>
                    </ol>
                </section>
            )
            : (
                <section className="content-header">
                    <h1>Юр.лицо {this.state.company.name}</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/companies/list">Юр. лица клиентов</NavLink></li>
                        <li className="active">{this.state.company.name}</li>
                    </ol>
                </section>
            );
        let passwordPlaceholder = isNew ? "" : "Для смены пароля укажите новый...";
        return (
            <div>
                {header}
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.name ? " has-error" : "")}>
                                                <label htmlFor="inputName">Юр. лицо клиента<span className="text-red">*</span></label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.name}
                                                    value={this.state.company.name}
                                                    onChange={value => this.handleTextInputChange("name", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.comment ? " has-error" : "")}>
                                                <label htmlFor="inputName">Комментарий</label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.comment}
                                                    value={this.state.company.comment}
                                                    onChange={value => this.handleTextInputChange("comment", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.inn ? " has-error" : "")}>
                                                <label htmlFor="inputInn">ИНН<span className="text-red">*</span></label>
                                                <TextInput id="inputInn"
                                                    title={this.state.errors.inn}
                                                    value={this.state.company.inn}
                                                    onChange={value => this.handleTextInputChange("inn", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.feeUsingYourCarrier ? " has-error" : "")}>
                                                <label htmlFor="feeUsingYourCarrier">Плата за пользование своим перевозчиком, р. с НДС</label>
                                                <NumberInput id="feeUsingYourCarrier"
                                                    title={this.state.errors.feeUsingYourCarrier}
                                                    value={this.state.company.feeUsingYourCarrier}
                                                    onChange={value => this.handleTextInputChange("feeUsingYourCarrier", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.showNewParcelForm ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsActive"
                                                            title={this.state.errors.showNewParcelForm}
                                                            checked={this.state.company.showNewParcelForm}
                                                            onChange={value => this.handleTextInputChange("showNewParcelForm", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Показ новой версии формы создания посылки
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.companyUsId ? " has-error" : "")}>
                                                <label htmlFor="selectCompanyUS">Юр. лицо US<span className="text-red">*</span></label>
                                                <SelectInput id="selectCompanyUS"
                                                    options={this.state.companiesUS}
                                                    value={this.state.company.companyUsId}
                                                    title={this.state.errors.companyUsId}
                                                    onChange={e => this.handleCompanyUSChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.carriers ? " has-error" : "")}>
                                                <label htmlFor="selectCarrier">Транспортные компании</label>
                                                <SelectInput id="selectCarrier"
                                                    options={this.state.carriers} multi
                                                    value={this.state.company.carriers}
                                                    title={this.state.errors.carriers}
                                                    onChange={e => this.handleCarriersChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.isActive ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsActive"
                                                            title={this.state.errors.isActive}
                                                            checked={this.state.company.isActive}
                                                            onChange={value => this.handleTextInputChange("isActive", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Активный
                                                    </label>
                                                </div>
                                            </div>       

                                            <div className={"form-group" + (this.state.errors.isInsuranceRequired ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsInsuranceRequired"
                                                            title={this.state.errors.isInsuranceRequired}
                                                            checked={this.state.company.isInsuranceRequired}
                                                            onChange={value => this.handleTextInputChange("isInsuranceRequired", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Страхование обязательно
                                                    </label>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-flat btn-default" onClick={() => this.backToList()} disabled={isBusy}>
                                        Отмена
                                    </button>
                                    <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save()} disabled={isBusy}>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/companies/companiesForm.jsx